import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetVisitModel } from "@factory/model/query-model-visit";
import { visitFormDefault } from "./form.default";
import { VisitFormSchema } from "./form.rule";

export const useFormDefaultVisit = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetVisitModel | undefined) => {
    return !cachedValue
      ? visitFormDefault
      : ({
          patient: cachedValue.patient,
          contract: cachedValue.contract,
          billing: cachedValue.billing,
          date: cachedValue.date,
          time: cachedValue.time,
          description: cachedValue.description,
          prescription: cachedValue.prescription,
          person: cachedValue.person,
        } as VisitFormSchema);
  };

  return {
    getDefault,
  };
};
